export const LanguageConstant = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE'
};
